import "./ConfirmButton.css"

type ConfirmButtonProps = {
    text: string,
    width?: string
    disabled?: boolean
    backgroundColor?: string
    onPress?: (e: any) => void
}

const ConfirmButton = ({ text, width, disabled, onPress, backgroundColor = "var(--picton-blue)" }:ConfirmButtonProps) => {
  return (
    <button 
        type="submit" 
        onClick={onPress}
        className={`${disabled ? "confirm-btn-modal-disabled" : "confirm-btn-modal pointer"} fs-11`} style={{ "width": width ? width : "14rem", opacity: disabled ? 0.7 : 1, backgroundColor }}
    >
        { text }
    </button>
  )
}

export default ConfirmButton